import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://github.com/paprisaha1999"
        className="home__social-icon"
        target="_blank"
      >
        <i class="uil uil-github-alt"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/papri-saha/"
        className="home__social-icon"
        target="_blank"
      >
        <i class="uil uil-linkedin-alt"></i>
      </a>
      <a
        href="https://twitter.com/stylopaps"
        className="home__social-icon"
        target="_blank"
      >
        <i class="uil uil-twitter-alt"></i>
      </a>
    </div>
  );
};

export default Social;
